import React from 'react';

export const MarkElement = (props) => {
  const { children, style } = props;
  const { isLast } = children.props;

  if (isLast) {
    return (
      <span style={style}>{children}</span>
    );
  }

  return children;
};
